import Table from "../../../../Components/Table";
import { ColumnDescription } from "react-bootstrap-table-next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCalendar,
    faCheck,
    faCheckSquare,
    faEdit,
    faEye,
    faTimes,
} from "@fortawesome/free-solid-svg-icons";
import {
    IListarComprovantesUsuarioRequest,
    IListarComprovantesUsuarioResponse,
} from "../../../../Interfaces/Vendas/Usuario/UsuarioInterface";
import moment from "moment";
import AgendaAtividadesFiltro from "./AgendaAtividadesFiltro/AgendaAtividadesFiltro";
import { IPropsTableChange } from "../../../../Interfaces/Geral/Atendimento/AtendimentoInterfaces";
import AgendaAtividadeDetalhes from "./AgendaAtividadesModal/AgendaAtividadeDetalhes";
import { useState } from "react";
import { IComponentModal } from "../../../../Components/Modais/IModalComponent";
import ModalComponent from "../../../../Components/Modais";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { ConcluirAtividadeVendasController } from "../../../../Controllers/Vendas/Caso/CasoController";
import Swal from "sweetalert2";
import { Spinner } from "../../../../Components/Loding/SpinnerPadrao";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useModuloInfo } from "../../../../Context/ModuloInfo";
import { DeletarCasoAtividadeController } from "../../../../Controllers/Cobranca/GestaoAtendimento/HistoricosControllers";
import CasoAtividade from "../../../../Components/CardsPages/HistoricoClienteCobranca/ComponenteHistorico/CasoAtividade";
import withReactContent from "sweetalert2-react-content";
import { ExportarCompromissosUsuarioExcelController } from "../../../../Controllers/Vendas/Usuario/UsuarioController";
import ExportExcel from "../../../../Components/StickyToolbar/ExportExcel";

interface IAgendaAtividades {
    filter: IListarComprovantesUsuarioRequest | undefined;
    handleSubmit(formData: IListarComprovantesUsuarioRequest): void;
    filtroInicial: IListarComprovantesUsuarioRequest;
    handleSearch(searchValue: string, newState: IPropsTableChange): void;
    lstCompromissosUsuario: IListarComprovantesUsuarioResponse[] | undefined;
    updateList?: any;
    FILTRO_AGENDA_ATIVIDADES: string | null;
    lstCompromissosUsuarioLoading: boolean;
    pesquisaText: string;
    setPesquisaText: React.Dispatch<React.SetStateAction<string>>;
    setFilter: (filter: IListarComprovantesUsuarioRequest) => void;
    calendarioAtividades: boolean;
}

export default function AgendaAtividades({
    filter,
    handleSubmit,
    handleSearch,
    lstCompromissosUsuario,
    updateList,
    filtroInicial,
    FILTRO_AGENDA_ATIVIDADES,
    lstCompromissosUsuarioLoading,
    pesquisaText,
    setPesquisaText,
    setFilter,
    // dateRange,
    calendarioAtividades,
}: IAgendaAtividades) {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const [atividadesSelecionadas, setAtividadesSelecionadas] =
        useState<Array<IListarComprovantesUsuarioResponse>>();

    const {
        execute: ConcluirAtividadeVendas,
        loading: ConcluirAtividadeVendasLoading,
    } = useAsyncCallback(ConcluirAtividadeVendasController);

    const {
        execute: DeletarCasoAtividade,
        loading: DeletarCasoAtividadeLoading,
    } = useAsyncCallback(DeletarCasoAtividadeController);

    const { id } = useModuloInfo();

    const MySwal = withReactContent(Swal);

    const renderAtividadesList = (
        atividadesSelecionadas: Array<IListarComprovantesUsuarioResponse>
    ) => {
        return `
        <ul style="text-align: left;">
            ${atividadesSelecionadas
                .map(
                    (ativ) => `
                <li>
                    <strong>Atividade:</strong> ${ativ.DS_TIPO_ATIVIDADE} <br/>
                    <strong>Cliente:</strong> ${ativ.DS_NOME_CLIENTE} <br/>
                    <strong>Responsável:</strong> ${ativ.DS_USUARIO_RESPONSAVEL} <br/>
                    <strong>Status:</strong> ${ativ.DS_STATUS}
                </li>
            `
                )
                .join("")}
        </ul>
    `;
    };

    function row(cell: any, row: IListarComprovantesUsuarioResponse) {
        const isTimeString =
            typeof row.DT_DURACAO === "string" &&
            row.DT_DURACAO.match(/^\d{2}:\d{2}:\d{2}$/);

        const formattedTime = isTimeString
            ? row.DT_DURACAO.slice(0, 5)
            : moment(row.DT_DURACAO).format("DD/MM/YYYY");

        const isTimeStringDtCasoAtividade =
            typeof row.DT_CASO_ATIVIDADE === "string" &&
            row.DT_CASO_ATIVIDADE.match(/^\d{2}:\d{2}:\d{2}$/);

        const formattedTimeDtCasoAtividade = isTimeStringDtCasoAtividade
            ? row.DT_CASO_ATIVIDADE.slice(0, 5)
            : moment(row.DT_CASO_ATIVIDADE).format("DD/MM/YYYY");

        return (
            <div
                key={row.ID_ATIVIDADE}
                className="d-flex justify-content-between align-items-center p-3"
            >
                <div className="d-flex flex-row align-items-center">
                    <div
                        className="mr-3 d-flex flex-column justify-content-center align-items-center"
                        style={{ minWidth: "150px", maxWidth: "150px" }}
                    >
                        <span className="font-weight-bold">
                            {formattedTimeDtCasoAtividade}{" "}
                            {(row.DT_DURACAO && formattedTime) ?? ""}
                        </span>
                        <div>
                            <span
                                className="badge badge-primary"
                                title={row.DS_TIPO_ATIVIDADE}
                            >
                                {row.DS_TIPO_ATIVIDADE}
                            </span>
                        </div>
                    </div>
                    <div className="d-flex flex-column align-items-start">
                        <div>
                            <span className="font-weight-bold">Protocolo:</span>{" "}
                            {row.ID_CASO}
                        </div>
                        <div>
                            <span className="font-weight-bold">
                                Responsável:
                            </span>{" "}
                            {row.DS_USUARIO_RESPONSAVEL}
                        </div>
                        <div>
                            <span className="font-weight-bold">Lead:</span>{" "}
                            {row.DS_NOME_CLIENTE}
                        </div>
                        <div>
                            <span className="font-weight-bold">
                                Comentário:
                            </span>{" "}
                            {row.DS_COMENTARIO}
                        </div>
                    </div>
                </div>
                <div className="d-flex justify-content-between align-items-center">
                    <div className="mr-4">
                        <span
                            className={`badge badge-${
                                row.DS_STATUS?.toString() === "executada"
                                    ? "success"
                                    : row.DS_STATUS?.toString() === "atrasada"
                                    ? "danger"
                                    : "warning"
                            } text-white`}
                        >
                            {row.DS_STATUS?.toString().charAt(0).toUpperCase() +
                                row.DS_STATUS?.toString().slice(1)}
                        </span>
                    </div>

                    <div>
                        <button
                            className="btn btn-outline-info"
                            onClick={() => {
                                if (row.ID_ATIVIDADE) {
                                    setShow(true);
                                    setModal({
                                        headerComponent: "Atividade",
                                        IconHeader: faCalendar,
                                        Component: () => (
                                            <AgendaAtividadeDetalhes
                                                compromissos={row}
                                                updateList={updateList}
                                            />
                                        ),
                                        noHeader: true,
                                        noFooter: true,
                                    });
                                }
                            }}
                        >
                            <FontAwesomeIcon icon={faEye} /> Ver Detalhes
                        </button>
                        <div className="d-flex justify-content-end mt-2">
                            <OverlayTrigger
                                overlay={
                                    <Tooltip id={`excluir-${row.ID_ATIVIDADE}`}>
                                        Excluir atividade
                                    </Tooltip>
                                }
                            >
                                <button
                                    className="btn btn-outline-danger mr-1"
                                    onClick={() => {
                                        Swal.fire({
                                            title: `Deseja excluir essa atividade?`,
                                            icon: "info",
                                            buttonsStyling: false,
                                            confirmButtonText:
                                                "<i class='la la-check'></i> Sim!",
                                            showCancelButton: true,
                                            cancelButtonText:
                                                "<i class='la la-thumbs-down'></i> Não",
                                            customClass: {
                                                confirmButton:
                                                    "btn btn-outline-danger",
                                                cancelButton: "btn btn-default",
                                            },
                                        }).then((result) => {
                                            if (result.isConfirmed) {
                                                DeletarCasoAtividade([
                                                    row.ID_ATIVIDADE,
                                                ]).then(() => {
                                                    if (updateList)
                                                        updateList();
                                                });
                                            }
                                        });
                                    }}
                                >
                                    {DeletarCasoAtividadeLoading ? (
                                        <Spinner size="sm" />
                                    ) : (
                                        <FontAwesomeIcon icon={faTimes} />
                                    )}{" "}
                                </button>
                            </OverlayTrigger>
                            <OverlayTrigger
                                overlay={
                                    <Tooltip
                                        id={`concluir-${row.ID_ATIVIDADE}`}
                                    >
                                        {!row.FL_CONCLUIDO
                                            ? "Concluir atividade"
                                            : "Atividade já concluída"}
                                    </Tooltip>
                                }
                            >
                                <button
                                    className="btn btn-outline-success mr-1"
                                    onClick={() => {
                                        Swal.fire({
                                            title: `Deseja concluir essa atividade?`,
                                            icon: "info",
                                            buttonsStyling: false,
                                            confirmButtonText:
                                                "<i class='la la-check'></i> Sim!",
                                            showCancelButton: true,
                                            cancelButtonText:
                                                "<i class='la la-thumbs-down'></i> Não",
                                            customClass: {
                                                confirmButton:
                                                    "btn btn-outline-success",
                                                cancelButton: "btn btn-default",
                                            },
                                        }).then((result) => {
                                            if (result.isConfirmed) {
                                                ConcluirAtividadeVendas([
                                                    {
                                                        ID_ATIVIDADE:
                                                            row.ID_ATIVIDADE,
                                                        ID_CASO: row.ID_CASO,
                                                    },
                                                ]).then(() => {
                                                    if (updateList)
                                                        updateList();
                                                });
                                            }
                                        });
                                    }}
                                    disabled={
                                        ConcluirAtividadeVendasLoading ||
                                        row.FL_CONCLUIDO
                                    }
                                >
                                    {ConcluirAtividadeVendasLoading ? (
                                        <Spinner size="sm" />
                                    ) : (
                                        <FontAwesomeIcon icon={faCheck} />
                                    )}{" "}
                                </button>
                            </OverlayTrigger>

                            <button
                                className="btn btn-outline-primary"
                                onClick={() => {
                                    if (
                                        row.ID_ATIVIDADE &&
                                        row.DS_TIPO_ATIVIDADE
                                    ) {
                                        setShow(true);
                                        setModal({
                                            headerComponent:
                                                "Cadastrar Atividade",
                                            IconHeader: faCheckSquare,
                                            Component: () => (
                                                <CasoAtividade
                                                    setShow={setShow}
                                                    row={row}
                                                    updateList={updateList}
                                                />
                                            ),
                                            size: "lg",
                                        });
                                    }
                                }}
                            >
                                <FontAwesomeIcon icon={faEdit} />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    const columns: Array<ColumnDescription> = [
        {
            dataField: "DS_NOME_CLIENTE",
            text: "Atividades",
            formatter: row,
            sort: true,
        },
    ];

    return (
        <>
            <div className="d-flex justify-content-end my-2">
                <button
                    className="btn btn-success"
                    disabled={
                        !atividadesSelecionadas ||
                        atividadesSelecionadas?.length === 0
                    }
                    onClick={() => {
                        MySwal.fire({
                            title: `Deseja concluir essa(s) ${atividadesSelecionadas?.length} atividade(s)?`,
                            html: renderAtividadesList(
                                atividadesSelecionadas ?? []
                            ),
                            icon: "info",
                            buttonsStyling: false,
                            confirmButtonText:
                                "<i class='la la-check'></i> Sim!",
                            showCancelButton: true,
                            cancelButtonText:
                                "<i class='la la-thumbs-down'></i> Não",
                            customClass: {
                                confirmButton: "btn btn-outline-success",
                                cancelButton: "btn btn-default",
                            },
                        }).then((result) => {
                            if (result.isConfirmed) {
                                ConcluirAtividadeVendas(
                                    atividadesSelecionadas?.map((ativ) => ({
                                        ID_ATIVIDADE: ativ.ID_ATIVIDADE,
                                        ID_CASO: ativ.ID_CASO,
                                    })) ?? []
                                ).then(() => {
                                    if (updateList) updateList();
                                    setAtividadesSelecionadas([]);
                                });
                            }
                        });
                    }}
                >
                    <FontAwesomeIcon icon={faCheck} /> Concluir atividades
                </button>
            </div>
            <Table
                keyField="ID_ATIVIDADE"
                columns={columns}
                data={lstCompromissosUsuario ?? []}
                loading={lstCompromissosUsuarioLoading}
                sizePerPage={5}
                noDataIndication={() => (
                    <div className="text-black-50 text-center">
                        Nenhuma atividade encontrada
                    </div>
                )}
                rowStyle={{ height: 50 }}
                striped={true}
                noHover
                center={true}
                onTableChange={(_type, newState) => {
                    const state = newState as IPropsTableChange;

                    if (state.searchText !== "") {
                        handleSearch(state.searchText, state);
                        setPesquisaText(state.searchText);
                    } else if (pesquisaText.length > 0) {
                        setFilter({
                            DS_PESQUISA: state.searchText,
                            DS_CLIENTE: filter?.DS_CLIENTE ?? "",
                            DS_STATUS: filter?.DS_STATUS ?? "",
                            ID_USUARIO_REQUEST:
                                filter?.ID_USUARIO_REQUEST ?? undefined,
                            DT_DATA_FN: filter?.DT_DATA_FN ?? undefined,

                            DT_DATA_IN: filter?.DT_DATA_IN ?? undefined,
                            ID_TIPO_ATIVIDADE: filter?.ID_TIPO_ATIVIDADE ?? 0,
                            ID_TIPO_CASO: id ?? 0,
                            ID_CASO: filter?.ID_CASO ? filter?.ID_CASO : 0,
                        });
                    }
                }}
                remote={{ search: true }}
                selectRow={{
                    mode: "checkbox",
                    clickToSelect: true,
                    nonSelectable: lstCompromissosUsuario?.map((lst) =>
                        lst.FL_CONCLUIDO ? lst.ID_ATIVIDADE : 0
                    ),
                    selected:
                        atividadesSelecionadas?.map(
                            (ativ) => ativ.ID_ATIVIDADE
                        ) ?? [],
                    onSelect: (row, isSelect) => {
                        if (isSelect) {
                            setAtividadesSelecionadas((prevAtividades) => [
                                ...(prevAtividades ?? []),
                                row,
                            ]);
                        } else {
                            setAtividadesSelecionadas((prevAtividades) =>
                                prevAtividades?.filter(
                                    (ativ) =>
                                        ativ.ID_ATIVIDADE !== row.ID_ATIVIDADE
                                )
                            );
                        }
                    },
                    onSelectAll: (isSelect, rows) => {
                        if (isSelect) {
                            setAtividadesSelecionadas(rows);
                        } else {
                            setAtividadesSelecionadas([]);
                        }
                    },
                }}
            />
            <AgendaAtividadesFiltro
                filter={filter}
                handleFilterFormSubmit={handleSubmit}
                handleSearch={handleSearch}
                filtroInicial={filtroInicial}
                FILTRO_AGENDA_ATIVIDADES={FILTRO_AGENDA_ATIVIDADES}
            />{" "}
            <ExportExcel
                baixarExcelController={async () =>
                    ExportarCompromissosUsuarioExcelController({
                        DS_CLIENTE: filter?.DS_CLIENTE ? filter.DS_CLIENTE : "",
                        DS_PESQUISA: filter?.DS_PESQUISA
                            ? filter.DS_PESQUISA
                            : "",
                        DS_STATUS: filter?.DS_STATUS ? filter.DS_STATUS : "",
                        DT_DATA_FN: filter?.DT_DATA_FN
                            ? filter.DT_DATA_FN
                            : undefined,
                        DT_DATA_IN: filter?.DT_DATA_IN
                            ? filter.DT_DATA_IN
                            : undefined,
                        ID_TIPO_ATIVIDADE: filter?.ID_TIPO_ATIVIDADE
                            ? filter.ID_TIPO_ATIVIDADE
                            : 0,
                        ID_USUARIO_REQUEST: filter?.ID_USUARIO_REQUEST
                            ? filter.ID_USUARIO_REQUEST
                            : undefined,
                        ID_TIPO_CASO: id ?? 0,
                        ID_CASO: filter?.ID_CASO ? filter?.ID_CASO : 0,
                    })
                }
                nomeArquivo={"Resumo_Atividades"}
            />
            <ModalComponent
                ModalComponent={modal}
                show={show}
                setShow={setShow}
            />
        </>
    );
}
